import React, { useEffect, useState } from "react";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_TYooMQauvdEDq54NiTphI7jx"); //TODO

function cssVar(name: string, fallback: string) {
  if (typeof window === "undefined") {
    return fallback;
  }
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
}

function stripeElementOptions() {
  return {
    style: {
      base: {
        color: cssVar("--bs-body-color", "#212529"),
        fontFamily: '"Open Sans", sans-serif',
        fontSize: "18px",
        "::placeholder": {
          color: cssVar("--bs-secondary-color", "#6c757d"),
        },
      },
      invalid: {
        color: cssVar("--bs-danger", "#dc1515"),
      },
    },
    classes: {
      base: "form-control form-control-lg",
      invalid: "is-invalid",
    },
  };
}

function EulaAgree(props) {
  return (
    <>
      <hr />
      <p className="text-center">
        <input type="checkbox" name="eula" id={props.id} required /> I agree to the{" "}
        <a href="/eula/">End User License Agreement</a> and <a href="/privacy/">Privacy Policy</a>
      </p>
    </>
  );
}

function PaymentSelection(props) {
  return (
    <div className="pay_methods text-center">
      <span className="pay_method">
        <input
          type="radio"
          name="payment_method"
          id="pay_paypal"
          value="paypal"
          onChange={() => props.selectPaymentMethod(PaymentMethod.Paypal)}
          className="payment_method_selector"
        />
        <label htmlFor="pay_paypal" className="pay_method_label">
          <img className="pay_method_box" src="/img/buy_paypal_logo.svg" width="153" height="111" alt="PayPal logo" />
          <br />
          <span className="pay_method_text">Pay with Paypal</span>
        </label>
      </span>
      <span className="pay_method">
        <input
          type="radio"
          name="payment_method"
          id="pay_cc"
          value="cc"
          onChange={() => props.selectPaymentMethod(PaymentMethod.Stripe)}
          className="payment_method_selector"
        />
        <label htmlFor="pay_cc" className="pay_method_label">
          <img className="pay_method_box" src="/img/buy_cc_logo.png" width="153" height="111" alt="credit card logos" />
          <br />
          <span className="pay_method_text">Pay with credit card</span>
        </label>
      </span>
    </div>
  );
}

enum PaymentMethod {
  None = 1,
  Stripe,
  Paypal,
}

function StripeForm(props) {
  const card_types = ["visa", "mastercard", "amex", "discover"];
  const stripe = useStripe();
  const elements = useElements();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [cardNumberError, setCardNumberError] = useState("");
  const [cardExpiryError, setCardExpiryError] = useState("");
  const [cardCvcError, setCardCvcError] = useState("");
  const [paymentError, setPaymentError] = useState("");
  const [elementOptions, setElementOptions] = useState(stripeElementOptions);

  useEffect(() => {
    const updateTheme = () => setElementOptions(stripeElementOptions());
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    media.addEventListener("change", updateTheme);

    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-bs-theme", "class", "style"],
    });

    return () => {
      media.removeEventListener("change", updateTheme);
      observer.disconnect();
    };
  }, []);

  // let updateCardClass = (current_brand) => {
  //   //deselect all first
  //   for (var index = 0; index < known_brands.length; index++) {
  //     brand = known_brands[index];
  //     var element = document.getElementById(brand + "-card");
  //     if(current_brand == brand || "unknown" == current_brand) {
  //       element.classList.remove("card-dimmed");
  //     } else {
  //       element.classList.add("card-dimmed");
  //     }

  //   }

  //   //select one if it's not unknown
  // };

  let card_icons = card_types.map((card_type) => (
    <img
      className="cardimg"
      src={"/img/pay/" + card_type + ".png"}
      height={40}
      width={64}
      id={card_type + "-card"}
      alt={card_type + " card"}
      key={card_type}
    />
  ));

  function submitToken(token: string) {
    const form = document.getElementById("payment-form") as HTMLFormElement;
    const tokenInput = document.createElement("input");
    tokenInput.setAttribute("type", "hidden");
    tokenInput.setAttribute("name", "stripe_id");
    tokenInput.setAttribute("value", token);
    form.appendChild(tokenInput);

    const emailInput = document.createElement("input");
    emailInput.setAttribute("type", "hidden");
    emailInput.setAttribute("name", "stripe_email");
    emailInput.setAttribute("value", email);
    form.appendChild(emailInput);

    form.submit();
  }

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setPaymentError("");

    if (!stripe || !elements) {
      setPaymentError("Payment form is still loading. Please try again.");
      return;
    }

    const cardNumber = elements.getElement(CardNumberElement);
    if (!cardNumber) {
      setPaymentError("Payment form failed to load. Please refresh the page.");
      return;
    }

    setSubmitting(true);
    const result = await stripe.createToken(cardNumber);
    setSubmitting(false);

    if (result.error) {
      setPaymentError(result.error.message || "Unable to process this card.");
      return;
    }
    if (!result.token) {
      setPaymentError("Stripe did not return a payment token.");
      return;
    }

    submitToken(result.token.id);
  }

  return (
    <div id="cc_payment">
      <div id="stripe_collect">
        <hr />
        <form action="/api/buy/complete" method="post" id="payment-form" className="payform ml-auto" onSubmit={handleSubmit}>
          <div className="ccdetails">
            <div className="form-row" style={{ marginBottom: "20px" }}>
              <label htmlFor="email-element">Email address</label>
              <div id="email-element" className="form-control form-control-lgs">
                <input
                  type="email"
                  placeholder="pilot@example.com"
                  style={{ border: "none", width: "100%", color: "var(--bs-body-color)", backgroundColor: "transparent" }}
                  id="form_email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
              <small>The license key will be delivered to this email address</small>
            </div>
            <div className="form-row">
              <label htmlFor="cardNumber-element">Card number</label>
              <CardNumberElement
                id="cardNumber-element"
                options={elementOptions}
                onChange={(event) => {
                  setCardNumberError(event.error?.message || "");
                  // TODO: re-enable card icon dimming when the visual treatment is finalized.
                }}
              />

              {/* Used to display form errors */}
              <div id="cardNumber-errors" role="alert" className="text-danger">{cardNumberError}</div>
            </div>
            <div className="form-row" id="cardimgrow">
              {card_icons}
            </div>
            <div className="form-row row">
              <div className="col-6">
                <label htmlFor="cardExpiry-element">Expiration</label>
                <CardExpiryElement
                  id="cardExpiry-element"
                  options={elementOptions}
                  onChange={(event) => setCardExpiryError(event.error?.message || "")}
                />
                {/* Used to display form errors */}
                <div id="cardExpiry-errors" role="alert" className="text-danger">{cardExpiryError}</div>
              </div>
              <div className="col-6">
                <label htmlFor="cardCvc-element">Security code</label>
                <CardCvcElement
                  id="cardCvc-element"
                  options={elementOptions}
                  onChange={(event) => setCardCvcError(event.error?.message || "")}
                />
                {/* Used to display form errors */}
                <div id="cardCvc-errors" role="alert" className="text-danger">{cardCvcError}</div>
              </div>
              <div style={{ clear: "both" }}>&nbsp;</div>
            </div>
            <div className="form-row">
              <div id="card-errors" role="alert" className="text-danger">{paymentError}</div>
              <small>
                Credit cards are securely processed with full encryption by our partner
                <a href="https://stripe.com"> Stripe</a>
              </small>
            </div>
          </div>
          <EulaAgree id="stripe-eula" />
          <hr />
          <div className="text-center">
            <p style={{ color: "darkgrey" }}>Click the button below to complete your purchase</p>
            <button type="submit" className="btn btn-lg btn-primary" id="stripe-continue" disabled={!stripe || submitting}>
              <i className="fa-solid fa-lock" aria-hidden="true"></i> Complete purchase
            </button>
          </div>
        </form>
        <div style={{ clear: "both" }}>&nbsp;</div>
      </div>
    </div>
  );
}

function PaypalForm(props) {
  return (
    <div id="paypal_payment">
      <form action="/api/buy/paypal_start" className="payform">
        <EulaAgree id="paypal-eula" />
        <hr />

        <div className="text-center">
          <p style={{ color: "darkgrey" }}>Click the button below to complete the transaction on PayPal's website</p>
          <button type="submit" className="btn btn-lg btn-primary" id="paypal-continue">
            Continue with Paypal <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </form>
    </div>
  );
}

export function PaymentForm(props) {
  let [payment_method, setPaymentMethod] = useState(PaymentMethod.None);

  return (
    <>
      <h3 className="text-center">Select Payment Method:</h3>
      <PaymentSelection selectPaymentMethod={setPaymentMethod} />
      {payment_method == PaymentMethod.Stripe && (
        <Elements stripe={stripePromise}>
          <StripeForm />
        </Elements>
      )}
      {payment_method == PaymentMethod.Paypal && <PaypalForm />}
      {payment_method == PaymentMethod.None && (
        <div id="none_payment">
          <p style={{ color: "darkgrey", textAlign: "center" }}>Select a payment method to continue</p>
        </div>
      )}
    </>
  );
}
